<div class="flex flex-row items-stretch space-x-6">
	<div
		[style.backgroundImage]="
			'url(' + (coachee.pictureUrl || picturePlaceholder) + ')'
		"
		class="bg-cover bg-center w-36 h-36 rounded-full flex-none"
	></div>
	<div class="flex flex-col items-stretch space-y-4">
		<div class="text-lg underline-none font-bold">{{ coachee.name }}</div>
		<div class="space-y-1">
			<div *ngIf="coachee.emailAddress" class="flex space-x-2">
				<i class="fas fa-envelope"></i>
				<span class="break-all">{{ coachee.emailAddress }}</span>
			</div>
			<div *ngIf="coachee.phoneNumber" class="flex space-x-2">
				<i class="fas fa-phone-alt"></i>
				<span class="break-all">{{ coachee.phoneNumber }}</span>
			</div>
		</div>
	</div>
</div>
<div class="flex flex-row space-x-6">
	<div class="w-36"></div>
	<div *ngIf="coachee" class="grid grid-cols-4 gap-3">
		<button
			[title]="
				'presentation.app.page.profile.coachee.actions.sendEmail' | translate
			"
			(click)="onSendEmailClick(coachee.emailAddress)"
			icon="fa fa-envelope"
			pButton
		></button>
		<button
			[title]="
				'presentation.app.page.profile.coachee.actions.addMeeting' | translate
			"
			(click)="onAddMeetingClick(coachee)"
			icon="fa fa-calendar-plus"
			pButton
		></button>
		<button
			(click)="openPlan.emit(coachee.id)"
			icon="fas fa-sitemap"
			pButton
			type="button"
		></button>
		<button
			(click)="openChat.emit(coachee.id)"
			icon="fas fa-comments"
			pButton
			type="button"
		></button>
	</div>
</div>
